import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';
import { RootState } from '@merchant-portal/slices';
import { ControlledDropdown } from '@merchant-portal/components/form-fields';
import getConstants from '@merchant-portal/util/constants';
import { CalendarStandard } from '@payright/web-components';

const { MONTHLY_PAYMENT_DATE_SELECTION } = getConstants();

type FormData = {
  selectedPaymentDate: Date | null;
  cardHolderName: string | null;
  cvc: string | null;
  expiry: string | null;
  selectedMonthlyDate: string | null;
};

const PaymentStartDate = () => {
  const checkout = useSelector((state: RootState) => state.checkout);
  const customer = useSelector((state: RootState) => state.customer);
  const repeatCustomer = customer?.accountDetails?.isReturnCustomer;
  // THIS IS THE NEXT REPAYMENT DATE
  const nextRepaymentDate = customer?.accountDetails?.nextRepaymentDate;

  const paymentFrequency = checkout.paymentDetails?.paymentFrequency;
  //const nextRepaymentDateReturningCustomer
  const [date, setDate] = useState(new Date());

  const { errors, setValue } = useFormContext<FormData>();

  return (
    <div className="payment-start-date-wrapper">
      {paymentFrequency === 'Monthly' && (
        <h4>Selected Repeating Day of the Month of Customer Repayments</h4>
      )}
      <div className="dateof-firstrepayment">
        {paymentFrequency === 'Monthly' && !repeatCustomer && (
          <ControlledDropdown
            name="selectedMonthlyDate"
            options={MONTHLY_PAYMENT_DATE_SELECTION}
            readOnly={false}
            rules={{ required: 'Required' }}
            error={errors.selectedMonthlyDate && 'Please select a day'}
          >
            Monthly Payment Day
          </ControlledDropdown>
        )}

        {nextRepaymentDate && repeatCustomer && (
          <h4>
            Your next payment date is -{' '}
            {new Date(nextRepaymentDate).toLocaleString('en-AU', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })}
          </h4>
        )}

        {paymentFrequency === 'Fortnightly' && !repeatCustomer && (
          <Controller
            onChangeName="handleInputChange"
            rules={{ required: true }}
            as={
              <CalendarStandard
                label="Date of first payment"
                value={date}
                minDate={new Date()}
                maxDate={new Date(new Date().setDate(new Date().getDate() + 2 * 7))} // Payment date can be with in two weeks
                // @ts-ignore
                handleDateChange={(date) => {
                  setValue('selectedPaymentDate', date);
                  setDate(date);
                }}
              />
            }
            name="selectedPaymentDate"
          ></Controller>
        )}

        {paymentFrequency === 'Weekly' && !repeatCustomer && (
          <Controller
            onChangeName="handleInputChange"
            rules={{ required: true }}
            as={
              <CalendarStandard
                label="Date of first payment"
                value={date}
                minDate={new Date()}
                maxDate={new Date(new Date().setDate(new Date().getDate() + 7))} // Payment date can be within one weeks
                // @ts-ignore
                handleDateChange={(date) => {
                  setValue('selectedPaymentDate', date);
                  setDate(date);
                }}
              />
            }
            name="selectedPaymentDate"
          ></Controller>
        )}
      </div>
    </div>
  );
};

export default PaymentStartDate;
